module.exports = __webpack_public_path__ + "img/cp-21.3633820d.png";